<app-header
  text="Standorte aktivieren"
  icon="fas fa-map-location-dot"></app-header>

<app-search-input
  (search)="search($event)"
  placeholder="Standorte durchsuchen ..."></app-search-input>
<div class="flex flex-column gap-2 mt-3">
  @for (poi of typeSelectItems; track poi._id) {
    <p-divider styleClass="my-2" />
    <div class="flex align-items-center gap-2">
      <p-checkbox
        [value]="poi._id"
        [(ngModel)]="selectedPoiIds"
        (ngModelChange)="onSelectionChange()"
        [inputId]="poi._id">
      </p-checkbox>
      <label
        [for]="poi._id"
        class="flex align-items-center gap-2 cursor-pointer">
        @if (poi.icon) {
          <app-svg-icon [key]="poi.icon"></app-svg-icon>
        }
        <span>{{ poi.name }}</span>
      </label>
    </div>
    @if (searchWord) {
      <div class="ml-4 mt-2">
        <app-poi-list
          [activeKey]="openPoiKey"
          (poiClicked)="callPoiClickEvent($event, poi._id)"
          [searchWord]="searchWord"
          [dataLayer]="layerStore.getLatestByParent(poi._id)" />
      </div>
    }
  }
</div>
